import {
  ProfileListSchema as ProfileListSchemaInternal,
  ProfileListsResponseSchema as ProfileListsResponseSchemaInternal,
} from '@sweetistics/contracts';
import type { z } from 'zod';

export const ProfileListSchema = ProfileListSchemaInternal;
export const ProfileListsResponseSchema = ProfileListsResponseSchemaInternal;

export type ProfileListInput = z.input<typeof ProfileListSchema>;
export type ProfileListOutput = z.output<typeof ProfileListSchema>;

export function serializeProfileList(payload: ProfileListInput): ProfileListOutput {
  return ProfileListSchema.parse(payload);
}

export type ProfileListsResponseInput = z.input<typeof ProfileListsResponseSchema>;
export type ProfileListsResponseOutput = z.output<typeof ProfileListsResponseSchema>;

export function serializeProfileListsResponse(payload: ProfileListsResponseInput): ProfileListsResponseOutput {
  return ProfileListsResponseSchema.parse(payload);
}
